import { createApp } from "vue";
import naive from "naive-ui";
import App from "./App.vue";
import router from './router'; // Путь к вашему файлу router.js
import store from './store';
const app = createApp(App);

app.use(store);
app.use(naive);
app.use(router);
app.mount("#app");